import Module from "./module";

export default Module;
